// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseSessionModel {
    static getAttributeTypeMap() {
        return CaseSessionModel.attributeTypeMap;
    }
}
CaseSessionModel.discriminator = undefined;
CaseSessionModel.attributeTypeMap = [
    {
        "name": "sessionId",
        "baseName": "sessionId",
        "type": "number"
    },
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "creationTime",
        "baseName": "creationTime",
        "type": "Date"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "entityId",
        "baseName": "entityId",
        "type": "number"
    }
];
//# sourceMappingURL=caseSessionModel.js.map